export default "__VITE_ASSET__CKxDKFZv__"